import produce from 'immer'

import { Types } from './actions'

const INITIAL_STATE = {
  isLoading: false
}

export default function fullpageLoaderReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.setGlobalLoading: {
        draft.isLoading = action.payload.isLoading
        break
      }

      default:
    }
  })
}
